export default __webpack_public_path__ + "static/media/cloud9-3.9f3a0b1a.png";